import React from "react";

import {
  Form,
  Col,
  Row,
  message,
  Input,
  Layout,
  Button,
  DatePicker,
  Radio,
  Select,
  Icon,
  Empty,
  Checkbox,
} from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";
const { Content } = Layout;
const plainOptions = ["Plan A", "Plan B", "Plan C"];
class ViewTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFields: [],
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    if (this.props.location.state) {
      this.api.invoke(
        "GetSRTemplateById/" + this.props.location.state,
        "get",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              this.setState({ SelectedFields: data.data.fields });
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        }
      );
    }
  }

  render() {
    return (
      <Content>
        <div className="mi_main_div" style={{ padding: "40px" }}>
          <div className="mi_box">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">View Template Fields</h4>
              </Col>
              <Col span={6}>
                <img
                  alt="example"
                  style={{ height: "182px", marginTop: "-80px" }}
                  src={img}
                />
              </Col>
            </Row>
          </div>
          <div
            style={{
              marginLeft: "-8px",
              marginRight: "-8px",
              marginTop: "50px",
            }}
          >
            <Row span={24} style={{ marginBottom: "-20px" }}>
              <Col>
                <Button
                  style={{ marginRight: "8px" }}
                  className="ant-btn table-operation submit-button ant-btn-primary"
                  onClick={() => {
                    this.props.history.push("/administration/managetemplate");
                  }}
                >
                  Back
                </Button>
              </Col>
            </Row>
            <div className="mi_main">
              <Form layout="vertical" hideRequiredMark>
                {this.state.SelectedFields &&
                this.state.SelectedFields.length > 0 ? (
                  this.state.SelectedFields.map((x) => {
                    if (x.fieldTypeName === "textarea") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input.TextArea
                                  disabled
                                  type="text"
                                  style={{ height: "100px" }}
                                  autoComplete={"nope"}
                                  className="mi_input"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "date") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset className="mi_input_pop">
                                <legend className="legend-font">
                                  {" "}
                                  {x.fieldLabelName}
                                </legend>

                                <DatePicker
                                  disabled
                                  autoComplete={"nope"}
                                  format="MM/DD/YYYY"
                                  className="mi_input"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "text") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input
                                  disabled
                                  className="mi_input"
                                  maxLength={40}
                                  type="text"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "email") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input
                                  disabled
                                  className="mi_input"
                                  maxLength={40}
                                  type="text"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "radio") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <legend
                                className="legend-font"
                                style={{
                                  marginLeft: "14px",
                                }}
                              >
                                {x.fieldLabelName}
                              </legend>

                              <Radio.Group
                                disabled
                                style={{
                                  marginLeft: "16px",
                                  marginTop: "20px",
                                }}
                              >
                                <Radio className="micompradio" value="male">
                                  Male
                                </Radio>
                                <Radio className="micompradio" value="female">
                                  Female
                                </Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "select") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Select
                                  disabled
                                  suffixIcon={
                                    <Icon
                                      style={{ transform: "rotate(90deg)" }}
                                      type="double-right"
                                    />
                                  }
                                  className="mi_input_profile"
                                  style={{ width: "150px" }}
                                  placeholder="Please Select"
                                  showSearch={true}
                                  filterOption={(input, option) =>
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                ></Select>
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "checkbox") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <legend
                                className="legend-font"
                                style={{
                                  marginLeft: "14px",
                                }}
                              >
                                {x.fieldLabelName}
                              </legend>

                              <Checkbox.Group
                                disabled
                                style={{
                                  marginLeft: "18px",

                                  borderColor: "#4E5693",
                                }}
                                options={plainOptions}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                  })
                ) : (
                  <Empty></Empty>
                )}
              </Form>
            </div>
          </div>
        </div>
      </Content>
    );
  }
}

export default ViewTemplate;
